/*
  ICM newsletter capture — behaviour for snippets/newsletter-form.liquid.

  WHY THIS IS AN ASSET AND NOT INLINE IN THE SNIPPET.
  The snippet renders inside sections/footer.liquid, which STRIPS NEWLINES AND
  DOUBLE SPACES. An inline <script> therefore arrives as a single line, and any
  "//" comment silently comments out the whole rest of the script. Measured
  2026-09-10 on the phase-2 preview: the inline version rendered with 0 newlines.
  Asset files are served as-is and are not touched by that stripping.

  WHY THE COPY COMES FROM data-* ATTRIBUTES AND NOT FROM LIQUID INTERPOLATION.
  The `t` filter HTML-escapes, so `{{ '...' | t | json }}` inside a <script> puts
  literal &#39; into a JS string and the customer reads "you&#39;re subscribed".
  Read from an attribute instead and the browser decodes the entity for us.

  TWO STEPS.
  1. email -> the discount code appears immediately, no email to wait for. There is no
     separate consent tick: the form is headed "Join our mailing list" with a Subscribe
     button, so submitting it is the affirmative act of consent.
  2. bike make -> recorded against the profile. Harley riders are then shown the
     Iron Stable join link; every other make just gets a thank-you and general comms.
     The link's href is rendered server-side through snippets/ist-url.liquid so it
     routes per market and locale — this file never builds an Iron Stable URL.
*/
(function () {
  if (window.__icmSubscribeInit) { return; }
  window.__icmSubscribeInit = true;

  function show(el, msg) { if (el) { el.textContent = msg; el.hidden = false; } }
  function hide(el) { if (el) { el.hidden = true; } }

  function post(endpoint, payload) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (body) { return { status: r.status, body: body }; });
    });
  }

  /* ---- step 1: email ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-icm-subscribe]') : null;
    if (!form) { return; }
    e.preventDefault();
    if (form.getAttribute('data-busy') === '1') { return; }

    var d = form.dataset;
    var okEl = form.querySelector('.icm-subscribe__ok');
    var errEl = form.querySelector('.icm-subscribe__err');
    var emailEl = form.querySelector('input[name="email"]');
    var email = ((emailEl && emailEl.value) || '').trim();

    hide(okEl); hide(errEl);

    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      show(errEl, d.msgInvalid);
      return;
    }

    form.setAttribute('data-busy', '1');

    post(d.endpoint, {
      email: email,
      /* Submitting a form headed "Join our mailing list" IS the affirmative act
         of consent — there is no separate tick to read. */
      marketing_consent: true,
      locale: d.locale || 'en',
      surface: d.icmSurface || 'newsletter'
    }).then(function (res) {
      form.removeAttribute('data-busy');

      if (res.status === 200 && res.body && res.body.ok) {
        okEl.textContent = d.msgOkSub + ' ';
        var code = document.createElement('strong');
        code.className = 'icm-subscribe__code';
        code.textContent = res.body.code;
        okEl.appendChild(code);
        okEl.hidden = false;

        var grp = form.querySelector('.input-group');
        if (grp) { grp.hidden = true; }
        /* step 2 — only offered when we got a token back to authorise it */
        if (res.body.token) {
          form.setAttribute('data-token', res.body.token);
          var bike = form.querySelector('.icm-subscribe__bike');
          if (bike) { bike.hidden = false; }
        }
        return;
      }

      if (res.status === 429) { show(errEl, d.msgRate); return; }
      if (res.status === 400 && res.body && res.body.error === 'invalid_email') {
        show(errEl, d.msgInvalid);
        return;
      }
      show(errEl, d.msgGeneric);
    }).catch(function () {
      form.removeAttribute('data-busy');
      show(errEl, d.msgGeneric);
    });
  });

  /* ---- step 2: bike make ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.icm-subscribe__bike-save') : null;
    if (!btn) { return; }
    var form = btn.closest('[data-icm-subscribe]');
    if (!form) { return; }
    e.preventDefault();

    var d = form.dataset;
    var token = form.getAttribute('data-token');
    var sel = form.querySelector('.icm-subscribe__make');
    var errEl = form.querySelector('.icm-subscribe__err');
    var doneEl = form.querySelector('.icm-subscribe__bike-done');
    var istEl = form.querySelector('.icm-subscribe__ist');

    if (!token || !sel || !sel.value) { return; }

    btn.disabled = true;
    hide(errEl);

    post(d.endpoint, {
      action: 'declare_bike',
      token: token,
      make: sel.options[sel.selectedIndex].text,
      make_norm: sel.value
    }).then(function (res) {
      btn.disabled = false;
      if (res.status === 200 && res.body && res.body.ok) {
        var row = sel.closest('.input-group');
        if (row) { row.hidden = true; }
        var lbl = form.querySelector('.icm-subscribe__bike-label');
        if (lbl) { lbl.hidden = true; }
        /* A Harley rider is offered Iron Stable; everyone else just gets thanked. */
        if (res.body.is_harley && istEl) { istEl.hidden = false; }
        else { show(doneEl, d.msgBikeThanks); }
        return;
      }
      show(errEl, d.msgGeneric);
    }).catch(function () {
      btn.disabled = false;
      show(errEl, d.msgGeneric);
    });
  });
})();
